import { render, staticRenderFns } from "./bigCouponItem.vue?vue&type=template&id=2ca257bd&scoped=true&"
import script from "./bigCouponItem.vue?vue&type=script&lang=ts&"
export * from "./bigCouponItem.vue?vue&type=script&lang=ts&"
import style0 from "./bigCouponItem.vue?vue&type=style&index=0&id=2ca257bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca257bd",
  null
  
)

export default component.exports